export default __webpack_public_path__ + "static/media/landing_page_reference_3.79a572da.jpg";